
@if (display) {
  <p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{ title | uppercase }}" [(visible)]="display" showEffect="fade" [modal]="true"
    [style]="{ width: '900px' }"
    appendTo="body">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <!-- #region BODY -->
    <div class="d-flex flex-column gap-3 p-3">
      <!-- CODE & NAME & SURNAME1-->
      <div class="row mt-3">
        <!-- CODE -->
        <div class="col-md-4">
          <div class="row">
            <div class="col-12">
              <label for="financing-type" class="custom-label">
                <label for="vehicle-data-settings-field2" class="form-label custom-label fw-bold small mb-2 me-2"><strong>
                  {{ 'drivers.form.code' | translate }} (*)
                </strong></label>
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <input type="text" id="vehicle-data-settings-field2"
                [(ngModel)]="entity.code" class="form-control custom-input" [disabled]="!isSaveGranted">
              </div>
            </div>
          </div>
          <!-- NAME -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="vehicle-data-settings-field3" class="form-label custom-label fw-bold small mb-2 me-2"><strong>
                  {{ 'drivers.form.name' | translate }} (*)
                </strong></label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <input type="text" id="vehicle-data-settings-field3"
                  [ngModel]="entity.user?.name" class="form-control custom-input" (change)="changeName($event)" [disabled]="!isSaveGranted">
              </div>
            </div>
          </div>
          <!-- SURNAME1 -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="financing-type" class="custom-label">
                  <label for="vehicle-data-settings-field2" class="form-label custom-label fw-bold small mb-2 me-2">
                    {{ 'drivers.form.surname' | translate }}
                  </label>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <input type="text" id="vehicle-data-settings-field2"
                  [ngModel]="entity.user?.surname1" (change)="changeSurname1($event)" class="form-control custom-input" [disabled]="!isSaveGranted">
              </div>
            </div>
          </div>
        </div>
        <!-- SURNAME2 & NIF & EXPIRATION NIF -->
        <div class="row mt-3">
          <!-- SURNAME2 -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="vehicle-data-settings-field3" class="form-label custom-label fw-bold small mb-2 me-2">
                  {{ 'drivers.form.secondSurname' | translate }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <input type="text" id="vehicle-data-settings-field3"
                  [ngModel]="entity.user?.surname2" (change)="changeSurname2($event)" class="form-control custom-input" [disabled]="!isSaveGranted">
              </div>
            </div>
          </div>
          <!-- NIF -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="financing-type" class="custom-label">
                  <label for="vehicle-data-settings-field2" class="form-label custom-label fw-bold small mb-2 me-2">
                    <strong>
                    {{ 'drivers.form.nif' | translate }} (*)</strong>
                  </label>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <input type="text" id="vehicle-data-settings-field2"
                  [(ngModel)]="entity.nif" class="form-control custom-input" [disabled]="!isSaveGranted">
              </div>
            </div>
          </div>
          <!-- EXPIRATION NIF -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="vehicle-data-settings-field3" class="form-label custom-label fw-bold small mb-2 me-2">
                  {{ 'drivers.form.expirationDateNif' | translate }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <input type="date" id="vehicle-data-settings-field3"
                  [(ngModel)]="entity.nifExpirationDate" class="form-control custom-input" [disabled]="!isSaveGranted">
              </div>
            </div>
          </div>
        </div>
        <!-- EXPEDITION NIF & DATE BIRTH & DIRECTION -->
        <div class="row mt-3">
          <!-- EXPEDITION NIF -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="financing-type" class="custom-label">
                  <label for="vehicle-data-settings-field2" class="form-label custom-label fw-bold small mb-2 me-2">
                    {{ 'drivers.form.expeditionDateNif' | translate }}
                  </label>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <input type="date"  id="vehicle-data-settings-field2"
                  [(ngModel)]="entity.nifExpeditionDate" class="form-control custom-input" [disabled]="!isSaveGranted">
              </div>
            </div>
          </div>
          <!-- DATE BIRTH -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="vehicle-data-settings-field3" class="form-label custom-label fw-bold small mb-2 me-2">
                  {{ 'drivers.form.birthDate' | translate }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <input type="date" id="vehicle-data-settings-field3"
                  [ngModel]="entity.user?.birthDate" (change)="changeBirthDate($event)" class="form-control custom-input" [disabled]="!isSaveGranted">
              </div>
            </div>
          </div>
          <!-- DIRECTION -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="vehicle-data-settings-field3" class="form-label custom-label fw-bold small mb-2 me-2">
                  {{ 'drivers.form.address' | translate }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <input type="text" id="vehicle-data-settings-field3"
                  [ngModel]="entity.user?.address" (change)="changeAddress($event)" class="form-control custom-input" [disabled]="!isSaveGranted">
              </div>
            </div>
          </div>
        </div>
        <!-- C.P & POPULATION & PHONE NUMBER -->
        <div class="row mt-3">
          <!-- C.P -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="financing-type" class="custom-label">
                  <label for="vehicle-data-settings-field2" class="form-label custom-label fw-bold small mb-2 me-2">
                    {{ 'drivers.form.postalCode' | translate }}
                  </label>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <input type="text" id="vehicle-data-settings-field2"
                  [ngModel]="entity.user?.cp" (change)="changeCp($event)" class="form-control custom-input" [disabled]="!isSaveGranted">
              </div>
            </div>
          </div>
          <!-- POPULATION -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="vehicle-data-settings-field3" class="form-label custom-label fw-bold small mb-2 me-2">
                  {{ 'drivers.form.population' | translate }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <input type="text" id="vehicle-data-settings-field3"
                  [ngModel]="entity.user?.population" (change)="changePopulation($event)" class="form-control custom-input" [disabled]="!isSaveGranted">
              </div>
            </div>
          </div>
          <!-- PHONE NUMBER -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="vehicle-data-settings-field3" class="form-label custom-label fw-bold small mb-2 me-2">
                  {{ 'drivers.form.phoneNumber' | translate }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <input type="text" id="vehicle-data-settings-field3"
                  [ngModel]="entity.user?.phoneNumber" (change)="changePhoneNumber($event)" class="form-control custom-input" [disabled]="!isSaveGranted">
              </div>
            </div>
          </div>
        </div>
        <!-- EXTENSION & MOBILE NUMBER & RPV -->
        <div class="row mt-3">
          <!-- EXTENSION -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="financing-type" class="custom-label">
                  <label for="vehicle-data-settings-field2" class="form-label custom-label fw-bold small mb-2 me-2">
                    {{ 'drivers.form.extension' | translate }}
                  </label>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <input type="text" id="vehicle-data-settings-field2"
                  [(ngModel)]="entity.extension" class="form-control custom-input" [disabled]="!isSaveGranted">
              </div>
            </div>
          </div>
          <!-- MOBILE NUMBER -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="vehicle-data-settings-field3" class="form-label custom-label fw-bold small mb-2 me-2">
                  {{ 'drivers.form.movil' | translate }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <input type="text" id="vehicle-data-settings-field3"
                  [(ngModel)]="entity.professionalPhoneNumber"  class="form-control custom-input" [disabled]="!isSaveGranted">
              </div>
            </div>
          </div>
          <!-- RPV -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="vehicle-data-settings-field3" class="form-label custom-label fw-bold small mb-2 me-2">
                  {{ 'drivers.form.rpv' | translate }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <input type="text" id="vehicle-data-settings-field3"
                  [(ngModel)]="entity.rpv" class="form-control custom-input" [disabled]="!isSaveGranted">
              </div>
            </div>
          </div>
        </div>
        <!-- PROFESSIONAL EMAIL & PERSONAL EMAIL & BILLING ACCOUNT-->
        <div class="row mt-3">
          <!-- PROFESSIONAL EMAIL -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="financing-type" class="custom-label">
                  <label for="vehicle-data-settings-field2" class="form-label custom-label fw-bold small mb-2 me-2"><strong>
                  {{ 'drivers.form.companyEmail' | translate }} (*)</strong>
                </label>
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <input type="text" id="vehicle-data-settings-field2"
                [(ngModel)]="entity.professionalEmail" class="form-control custom-input" [disabled]="!isSaveGranted">
            </div>
          </div>
        </div>
        <!-- PERSONAL EMAIL -->
        <div class="col-md-4">
          <div class="row">
            <div class="col-12">
              <label for="vehicle-data-settings-field3" class="form-label custom-label fw-bold small mb-2 me-2">
                {{ 'drivers.form.personalEmail' | translate }}
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <input type="text" id="vehicle-data-settings-field3"
                [(ngModel)]="entity.email" class="form-control custom-input" [disabled]="!isSaveGranted">
            </div>
          </div>
        </div>
        <!-- BILLING ACCOUNT -->
        <div class="col-md-4">
          <div class="row">
            <div class="col-12">
              <label for="vehicle-data-settings-field3" class="form-label custom-label fw-bold small mb-2 me-2">
                {{ 'drivers.form.company' | translate }}
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p-select [options]='billingAccountList'
                [ngModel]='selectedBillingAccount' i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}" dataKey='id'
                optionLabel='formatBillingAccountLabel' [style]="{'width':'100%', 'margin-right':'5px'}"
                appendTo='body' filter="true" (onChange)="onChangeBillingAccount($event)" (onFilter)="onFilterBillingAccount($event)"
                [disabled]="!isSaveGranted">
                <ng-template let-billingAccount pTemplate="item">
                  <div class="flex align-items-center gap-2">
                    <div>
                      ({{ billingAccount.code }}) {{ billingAccount.name }}
                    </div>
                  </div>
                </ng-template>
              </p-select>
            </div>
          </div>
        </div>
      </div>
      <!-- CECO & DIVISION & SUBDIVISION-->
      <div class="row mt-3">
        <!-- CECO -->
        <div class="col-md-4">
          <div class="row">
            <div class="col-12">
              <label for="vehicle-data-settings-field3" class="form-label custom-label fw-bold small mb-2 me-2">
                {{ 'drivers.form.ceco' | translate }}
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p-select [options]='cecoList'
                [ngModel]='selectedCeco' i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}" dataKey='id'
                optionLabel='formatCecoLabel' [style]="{'width':'100%', 'margin-right':'5px'}"
                appendTo='body' filter="true" (onChange)="onChangeCeco($event)" (onFilter)="onFilterCeco($event)"
                [disabled]="!selectedBillingAccount || !isSaveGranted"
                >
                <ng-template let-ceco pTemplate="item">
                  <div class="flex align-items-center gap-2">
                    <div>
                      ({{ ceco.code }}) {{ ceco.description }}
                    </div>
                  </div>
                </ng-template>
              </p-select>
            </div>
          </div>
        </div>
        <!-- DIVISION -->
        <div class="col-md-4">
          <div class="row">
            <div class="col-12">
              <label for="vehicle-data-settings-field3" class="form-label custom-label fw-bold small mb-2 me-2">
                {{ 'drivers.form.division' | translate }}
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p-select [options]='divisionList'
                [ngModel]='selectedDivision' i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}" dataKey='id'
                optionLabel='formatDivisionLabel' [style]="{'width':'100%', 'margin-right':'5px'}"
                appendTo='body' filter="true" (onChange)="onChangeDivision($event)" (onFilter)="onFilterDivision($event)"
                [disabled]="!isSaveGranted">
                <ng-template let-division pTemplate="item">
                  <div class="flex align-items-center gap-2">
                    <div>
                      ({{ division.code }}) {{ division.name }}
                    </div>
                  </div>
                </ng-template>
              </p-select>
            </div>
          </div>
        </div>
        <!-- SUBDIVISION -->
        <div class="col-md-4">
          <div class="row">
            <div class="col-12">
              <label for="vehicle-data-settings-field3" class="form-label custom-label fw-bold small mb-2 me-2">
                {{ 'drivers.form.subdivision' | translate }}
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p-select [options]='subDivisionList'
                [ngModel]='selectedSubDivision' i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}" dataKey='id'
                optionLabel='formatSubDivisionLabel' [style]="{'width':'100%', 'margin-right':'5px'}"
                appendTo='body' filter="true" (onChange)="onChangeSubDivision($event)" (onFilter)="onFilterSubDivision($event)"
                [disabled]="!selectedDivision || !isSaveGranted"
                >
                <ng-template let-subDivision pTemplate="item">
                  <div class="flex align-items-center gap-2">
                    <div>
                      ({{ subDivision.code }}) {{ subDivision.name }}
                    </div>
                  </div>
                </ng-template>
              </p-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
      <div class="d-flex justify-content-center bd-highlight">
        <div class="p-2 bd-highlight">
          @if (isNew && isSaveGranted) {
            <div>
              <button class="btn custom-button" (click)="saveDriver()" i18n>
                        {{'general.create' | translate}}
                    </button>
            </div>
          }
          @if (!isNew && isSaveGranted) {
            <div>
              <button class="btn custom-button" (click)="saveDriver()" i18n>
                        {{'general.save' | translate}}
                    </button>
            </div>
          }
        </div>
      </div>
    </ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}